import React from "react";
import "../../../styles/ComponentsStyles/Universal/Tables/ScrollableTable.style.css";
import PropTypes from "prop-types";
const ScrollableTable = ({ headerTextColor="var(--grayColor)", thead, className, children }) => {
  return (
    <table id="scrollableTableUniversal" className={className}>
      <thead>
        <tr>
          {thead &&
            thead.map((th, index) => {
              return (
                <th
                  style={{
                    "--scrollableUniversalTableHeadeColor": headerTextColor,
                  }}
                  key={index}
                >
                  {th}
                </th>
              );
            })}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};

export default ScrollableTable;

ScrollableTable.propTypes = {
  headerTextColor: PropTypes.string,
  thead: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
